import { SalesforceActionCreatorFactoryBase } from './salesforce.actionCreator.factory-base';
import { SoftphoneActionCreator } from '../softphone/softphone.actioncreator';
import { SalesforceLightningSoftphoneActionCreator } from './salesforceLightning.softhpone.actioncreator';

export default class SalesforceLightningActionCreatorFactory extends SalesforceActionCreatorFactoryBase {
  public createSoftphoneActionCreator(): SoftphoneActionCreator {
    return new SalesforceLightningSoftphoneActionCreator(this.salesforceLightningProxy);
  }
}
